export function getElementHeight(element: HTMLElement): number {
  const computedStyle = getComputedStyle(element);
  const paddingTop = parseFloat(computedStyle.paddingTop);
  const paddingBottom = parseFloat(computedStyle.paddingBottom);
  return element.clientHeight - paddingTop - paddingBottom;
}
